import type { Idioma } from "./IdiomaProvider";

// Apenas vocabulário fixo da interface. Nomes, códigos e opções cadastradas não entram nesta lista.
const ROTULOS = [
  ["Ativo", "Active", "Activo", "启用"],
  ["Ativa", "Active", "Activa", "启用"],
  ["Inativo", "Inactive", "Inactivo", "停用"],
  ["Inativa", "Inactive", "Inactiva", "停用"],
  ["Válido", "Valid", "Válido", "有效"],
  ["Inválido", "Invalid", "Inválido", "无效"],
  ["Aberto", "Open", "Abierto", "未结"],
  ["Aberta", "Open", "Abierta", "未结"],
  ["Em aberto", "Open", "Pendiente", "未结"],
  ["Fechado", "Closed", "Cerrado", "已关闭"],
  ["Concluído", "Completed", "Completado", "已完成"],
  ["Concluída", "Completed", "Completada", "已完成"],
  ["Finalizado", "Finished", "Finalizado", "已结束"],
  ["Encerrado", "Closed", "Cerrado", "已关闭"],
  ["Parcelada", "In installments", "En cuotas", "分期付款"],
  ["Parcelado", "In installments", "En cuotas", "分期付款"],
  ["Pago", "Paid", "Pagado", "已支付"],
  ["Paga", "Paid", "Pagada", "已支付"],
  ["Recebida", "Received", "Recibida", "已收款"],
  ["Recebido", "Received", "Recibido", "已收到"],
  ["A vencer", "Not yet due", "Por vencer", "未到期"],
  ["Vencido", "Overdue", "Vencido", "已逾期"],
  ["Vencida", "Overdue", "Vencida", "已逾期"],
  ["Pendente", "Pending", "Pendiente", "待处理"],
  ["Aguardando", "Waiting", "En espera", "等待中"],
  ["Em andamento", "In progress", "En curso", "进行中"],
  ["Em análise", "Under review", "En revisión", "审核中"],
  ["Resolvido", "Resolved", "Resuelto", "已解决"],
  ["Entregue", "Delivered", "Entregado", "已交付"],
  ["Aprovado", "Approved", "Aprobado", "已批准"],
  ["Rejeitado", "Rejected", "Rechazado", "已拒绝"],
  ["Recusado", "Declined", "Rechazado", "已拒绝"],
  ["Convertido", "Converted", "Convertido", "已转换"],
  ["Cancelado", "Canceled", "Cancelado", "已取消"],
  ["Cancelada", "Canceled", "Cancelada", "已取消"],
  ["Entrada", "Incoming", "Entrada", "入库"],
  ["Saída", "Outgoing", "Salida", "出库"],
  ["Saída Avulsa", "Standalone outgoing", "Salida independiente", "独立出库"],
  ["Balanço", "Inventory count", "Inventario", "盘点"],
  ["Baixo", "Low", "Bajo", "低"],
  ["Baixa", "Low", "Baja", "低"],
  ["Normal", "Normal", "Normal", "正常"],
  ["Zerado", "Zero", "En cero", "零"],
  ["Média", "Medium", "Media", "中"],
  ["Alta", "High", "Alta", "高"],
  ["Urgente", "Urgent", "Urgente", "紧急"],
  ["Crítica", "Critical", "Crítica", "严重"],
  ["Venda", "Sale", "Venta", "销售"],
  ["Serviço", "Service", "Servicio", "服务"],
  ["Orçamento", "Quote", "Presupuesto", "报价"],
  ["Pedido", "Order", "Pedido", "订单"],
  ["Parcela", "Installment", "Cuota", "分期"],
  ["Dinheiro", "Cash", "Efectivo", "现金"],
  ["Cartão", "Card", "Tarjeta", "银行卡"],
  ["Crediário", "Store credit", "Crédito de tienda", "赊账"],
  ["Boleto", "Payment slip", "Boleta de pago", "付款单"],
  ["Transferência", "Transfer", "Transferencia", "转账"],
  ["Envio", "Shipping", "Envío", "发货"],
  ["Retirada", "Pickup", "Retiro", "自提"],
  ["Interno", "Internal", "Interno", "内部"],
  ["Externo", "External", "Externo", "外部"],
  ["Externa", "External", "Externa", "外部"],
  ["Costura interna", "In-house sewing", "Costura interna", "内部缝制"],
  ["Matriz", "Head office", "Casa matriz", "总部"],
  ["Filial", "Branch", "Sucursal", "分支机构"],
  ["Habilitado", "Enabled", "Habilitado", "已启用"],
  ["Desabilitado", "Disabled", "Deshabilitado", "已禁用"],
  ["Conectada", "Connected", "Conectada", "已连接"],
  ["Desconectada", "Disconnected", "Desconectada", "已断开"],
  ["Muito ruim", "Very poor", "Muy malo", "很差"],
  ["Ruim", "Poor", "Malo", "差"],
  ["Regular", "Fair", "Regular", "一般"],
  ["Bom", "Good", "Bueno", "良好"],
  ["Excelente", "Excellent", "Excelente", "优秀"],
  ["Major", "Major", "Mayor", "主版本"],
  ["Minor", "Minor", "Menor", "次版本"],
  ["Patch", "Patch", "Parche", "补丁"],
  ["Camiseta", "T-shirt", "Camiseta", "T恤"],
  ["Polo", "Polo shirt", "Polo", "Polo衫"],
  ["Regata", "Tank top", "Camiseta sin mangas", "背心"],
  ["Calça", "Pants", "Pantalón", "长裤"],
  ["Bermuda", "Shorts", "Bermudas", "短裤"],
  ["Moletom", "Sweatshirt", "Sudadera", "卫衣"],
  ["Outros", "Others", "Otros", "其他"],
  ["Corte", "Cutting", "Corte", "裁剪"],
  ["Preparação", "Preparation", "Preparación", "准备"],
  ["Montagem", "Assembly", "Montaje", "组装"],
  ["Costura", "Sewing", "Costura", "缝制"],
  ["Aplicação de etiqueta", "Label application", "Aplicación de etiqueta", "贴标"],
  ["Revisão", "Inspection", "Revisión", "检查"],
  ["Acabamento", "Finishing", "Acabado", "整理"],
  ["Embalagem", "Packaging", "Embalaje", "包装"],
  ["Ativação enviada", "Activation sent", "Activación enviada", "激活信息已发送"],
  ["Ativação enviada por WhatsApp", "Activation sent via WhatsApp", "Activación enviada por WhatsApp", "已通过WhatsApp发送激活信息"],
  ["Ativação enviada por e-mail", "Activation sent via email", "Activación enviada por correo", "已通过电子邮件发送激活信息"],
  ["Cobrança enviada", "Payment reminder sent", "Recordatorio de pago enviado", "付款提醒已发送"],
  ["Cobrança manual por WhatsApp", "Manual payment reminder via WhatsApp", "Recordatorio de pago manual por WhatsApp", "通过WhatsApp手动提醒付款"],
  ["Cobrança manual por e-mail", "Manual payment reminder via email", "Recordatorio de pago manual por correo", "通过电子邮件手动提醒付款"],
  ["Cobrança automática por WhatsApp", "Automatic payment reminder via WhatsApp", "Recordatorio de pago automático por WhatsApp", "通过WhatsApp自动提醒付款"],
  ["Cobrança automática por e-mail", "Automatic payment reminder via email", "Recordatorio de pago automático por correo", "通过电子邮件自动提醒付款"],
  ["Envio de cobrança", "Send payment reminder", "Enviar recordatorio de pago", "发送付款提醒"],
  ["Pagamento recusado", "Payment declined", "Pago rechazado", "付款被拒绝"],
  ["Prazo próximo", "Deadline approaching", "Plazo próximo", "即将到期"],
] as const;

const criar = (indice: 0 | 1 | 2 | 3): Record<string, string> =>
  Object.fromEntries(ROTULOS.map((rotulo) => [rotulo[0], rotulo[indice]]));

export const TEXTOS_BADGES: Record<Idioma, Record<string, string>> = {
  pt: criar(0),
  en: criar(1),
  es: criar(2),
  "zh-CN": criar(3),
};
